import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, ButtonResponsiveWrapper, TaxFormIcon, useResponsive } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
import { useHistory } from '@/modules/core/hooks';
import { useMyEnrollments } from '@/modules/transaction';

interface Props {
  isWideMode?: boolean;
  onDismiss: () => void;
}

const TaxFormBanner: React.FC<Props> = ({ isWideMode, onDismiss }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { mainHSAEnrollment } = useMyEnrollments();
  const history = useHistory();

  const handleRedirect = useCallback(() => {
    if (mainHSAEnrollment) {
      history.push(ROUTES.TAX_FORMS(mainHSAEnrollment.id));
    }
  }, [history, mainHSAEnrollment]);

  return (
    <>
      <Box data-testid="auto-investment-banner">
        <Banner
          isWideMode={isWideMode}
          title={t('Your Tax Forms are Ready')}
          description={t('Access your HSA tax forms here.')}
          icon={<TaxFormIcon />}
          testId="tax-form"
        >
          <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
            <AppButton fill={isMobile} testId="tax-form_view" width="180px" onClick={handleRedirect}>
              {t('View')}
            </AppButton>

            <AppButton
              fill={isMobile}
              testId="tax-form_dismiss"
              buttonType="secondary"
              width="180px"
              onClick={onDismiss}
            >
              {t('Dismiss')}
            </AppButton>
          </ButtonResponsiveWrapper>
        </Banner>
      </Box>
    </>
  );
};

export default TaxFormBanner;
